<sc-flex vertical stretchContent [gap]="16" [formGroup]="formGroup">
  <sc-select-field labelDictionaryKey="tmc-yard.common.process" formControlName="process" [data]="processSelectOptions"></sc-select-field>
  <sc-select-field labelDictionaryKey="tmc-yard.common.processStep" formControlName="processStep" [data]="processStepSelectOptions" [disabled]="currenProcess == null"></sc-select-field>
</sc-flex>
